import Vue from 'vue'
import {
  CLEAR_CHALLENGE,
  SAVE_FIELD,
  RM_FIELD,
  SET_CHALLENGE,
  SET_CHALLENGE_ADDRESS,
  SET_CHALLENGE_PERIODS,
  SET_PARENT_TYPE,
  SET_CURRENT_RELATIONSHIP_TYPE,
  TOGGLE_CHALLENGE_ADDRESS_MODAL,
  TOGGLE_CHALLENGE_PERIODS,
  TOGGLE_CHALLENGE_EXPIRATION_MODAL,
  TOGGLE_CHALLENGE_LEI_CODE_MODAL,
  TOGGLE_CHALLENGE_MODAL,
  TOGGLE_CHALLENGE_RELATIONSHIP_DETAILS_MODAL,
  TOGGLE_CHALLENGE_RELATIONSHIP_MODAL,
  TOGGLE_SUMMARY_MODAL,
  SET_RELATIONSHIP_DETAILS,
  RM_FIELDS,
} from './mutations-types'

export default {
  [SAVE_FIELD] (state, newField) {
    const oldFieldIndex = state.fields.findIndex(({ jsonPath, }) => newField.jsonPath === jsonPath)
    if (oldFieldIndex !== -1) {
      Vue.set(state.fields, oldFieldIndex, newField)
    } else {
      state.fields.push(newField)
    }
  },
  [RM_FIELD] (state, jsonPath) {
    state.fields = state.fields.filter((field) => field.jsonPath !== jsonPath)
  },
  [RM_FIELDS] (state, jsonPath) {
    state.fields = state.fields.filter((field) => !field.jsonPath.includes(jsonPath))
  },
  [CLEAR_CHALLENGE] (state) {
    state.fields = []
    state.currentRelationshipTypes = {
      directParent: '',
      ultimateParent: '',
      fundManager: '',
      umbrellaFund: '',
      masterFund: '',
      headOffice: '',
    }
  },
  [SET_CHALLENGE] (state, { fieldId, text, title, oldValue = '', type = 'STRING', jsonPath, exchange, autocompleteEntity = false, }) {
    state.challenge = {
      fieldId,
      type,
      text,
      title,
      oldValue,
      jsonPath,
      exchange,
      autocompleteEntity,
    }
  },
  [SET_CHALLENGE_ADDRESS] (state, { rootPath, country = '', addressLines = [], addressNumber, addressNumberWithinBuilding, mailRouting, postalCode = '', city = '', region = '', title = '', }) {
    state.challengeAddress = {
      country,
      addressLines,
      addressNumber,
      addressNumberWithinBuilding,
      mailRouting,
      postalCode,
      city,
      region,
      title,
      rootPath,
    }
  },
  [SET_CHALLENGE_PERIODS] (state, { type, startDate, endDate, title, }) {
    state.challengePeriods = {
      type,
      startDate,
      endDate,
      title,
    }
  },
  [TOGGLE_SUMMARY_MODAL] (state, value) {
    state.showSummaryModal = value
  },
  [TOGGLE_CHALLENGE_MODAL] (state, value) {
    state.showChallengeModal = value || !state.showChallengeModal
  },
  [TOGGLE_CHALLENGE_ADDRESS_MODAL] (state, value) {
    state.showChallengeAddressModal = value || !state.showChallengeAddressModal
  },
  [TOGGLE_CHALLENGE_PERIODS] (state, value) {
    state.showChallengePeriodsModal = value || !state.showChallengePeriodsModal
  },
  [TOGGLE_CHALLENGE_EXPIRATION_MODAL] (state, value) {
    state.showChallengeExpirationModal = value || !state.showChallengeExpirationModal
  },
  [TOGGLE_CHALLENGE_RELATIONSHIP_DETAILS_MODAL] (state, value) {
    state.showChallengeRelationshipDetailsModal = value || !state.showChallengeRelationshipDetailsModal
  },
  [TOGGLE_CHALLENGE_RELATIONSHIP_MODAL] (state, value) {
    state.showChallengeRelationshipModal = value || !state.showChallengeRelationshipModal
  },
  [SET_PARENT_TYPE] (state, { type, }) {
    state.parentType = type
  },
  [SET_RELATIONSHIP_DETAILS] (state, { data, }) {
    state.challengeRelationshipDetails = data
  },
  [SET_CURRENT_RELATIONSHIP_TYPE] (state, { parentType, relationshipType, }) {
    state.currentRelationshipTypes[parentType] = relationshipType
  },
  [TOGGLE_CHALLENGE_LEI_CODE_MODAL] (state, value) {
    state.showChallengeLeiCodeModal = value || !state.showChallengeLeiCodeModal
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/record/modules/challenge/mutations.js